import { ReservationPreference } from '@dreryk/egabinet-waitlist-frontend-api';

export const RESERVATION_PREFERENCES: ReservationPreference[] = ['PRACTITIONER', 'LOCATION', 'TIME'];
